import { PolicyMeta } from '@/lib/models/policy-model';
import { PolicyMeta as PolicyMetaV1 } from '@/lib/models/policy-model-v1';
import { useNavigate } from '@tanstack/react-router';
import { FC } from 'react';
import { EntityLink } from '../entity-link';
import useFeature from '@/hooks/use-feature.hook';
import Icon from '../icon';
import { ScrollAnchorId } from '../scroll-anchor/helpers';
import { getPolicyLink } from './helpers';

interface Props {
  policy: PolicyMeta | PolicyMetaV1;
  policyLinkTab?: string;
  policyLinkScrollId?: ScrollAnchorId;
}

const PolicyLink: FC<Props> = ({ policy, policyLinkTab = 'portal', policyLinkScrollId }) => {
  const navigate = useNavigate();

  const { name, isDefault } = policy;
  const { hasPolicyV2 } = useFeature();

  const fullHref = getPolicyLink(policy, hasPolicyV2, policyLinkTab, policyLinkScrollId);

  return (
    <EntityLink
      title={name}
      image={isDefault ? <Icon name="organization" size="small" /> : undefined}
      variant="outlined"
      onClick={() => {
        navigate({
          to: fullHref,
        });
      }}
    />
  );
};

export default PolicyLink;
